<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <section class="section hero-section product-list-section">
        <div class="page-inside-top">
          <div class="wrapper">
            <div class="bradcrumbs">
              <div class="desc">
                {{ $t("CS2") }}
              </div>
              <div class="desc active">
                {{ $t("All items") }}
              </div>
            </div>
          </div>
        </div>
        <div class="page-inside-wrapper">
          <div class="wrapper">
            <div class="category-list">
              <div class="left">
                <div class="filter-button">
                  <div class="desc">
                    <b>
                      {{ $t("Filter") }}
                    </b>
                  </div>
                </div>
                <div class="filters-block filters-top">
                  <button class="button" @click="resetFilters">
                    {{ $t("Clear filters") }}
                  </button>
                </div>
              </div>

              <Categories @setProductCategory="setProductCategory" />
            </div>
            <div class="bar">
              <div class="desc">{{ totalProducts }} {{ $t("items") }}</div>
              <Select2
                v-model="sort"
                class="select2 single currency-select"
                :options="sortOptions"
                :placeholder="$t('Highest price first')"
                @select="selectSort($event)"
              />
            </div>
            <div class="product-container">
              <transition name="slide2">
                <div
                  v-show="filtersIsVisible"
                  :class="['top', { 'not-full': !filtersIsVisible }]"
                >
                  <div class="filters">
                    <div class="filters-wrapper">
                      <div class="filters-block filters-price">
                        <div class="desc">
                          <b>{{ $t("Price") }}</b>
                        </div>
                        <div class="val-container">
                          <div class="val min">
                            <div class="desc desc-name">
                              {{ $t("In:") }}
                            </div>
                            <img class="coin" src="./../assets/coin.png" />
                            <input v-model="barMinValue" type="number" />
                          </div>
                          <div class="val max">
                            <div class="desc desc-name">
                              {{ $t("Until:") }}
                            </div>

                            <img class="coin" src="./../assets/coin.png" />

                            <input v-model="barMaxValue" type="number" />
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="qualityOptions.length"
                        class="filters-block filters-quality"
                      >
                        <div class="desc">
                          <b>{{ $t("Quality") }}</b>
                        </div>
                        <label
                          v-for="(item, i) in qualityOptions"
                          :key="i"
                          class="chekbox-label"
                        >
                          <div class="chekbox-label-wrapper">
                            <input
                              v-model="quality"
                              type="checkbox"
                              :value="item"
                            />
                            <div class="checkbox" />
                            <span class="title">{{ $t(item) }}</span>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="productList && productList.length"
                  :class="['list products', { full: !filtersIsVisible }]"
                >
                  <div v-for="(item, i) in productList" :key="i" class="item">
                    <ProductCard
                      :categories="[]"
                      :item="item"
                      :add-to-cart-chosen-item="addToCartChosenItem"
                      :slider-is-clickble="true"
                      :currency="currency"
                      @goToProduct="goToProduct"
                      @addToCart="addToCart"
                    />
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="productList && !productList.length"
                  class="title small no-products"
                >
                  {{ $t("No products!") }}
                </div>
              </transition>
            </div>
            <pagination
              v-if="totalProducts"
              v-model="activePage"
              :records="totalProducts"
              :per-page="20"
              @paginate="changePage"
            />
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import Pagination from "vue-pagination-2";
import ProductCard from "../components/ProductCard.vue";
import Categories from "../components/Categories.vue";
import Select2 from "vue3-select2-component";

export default {
  name: "ProductListPage",
  components: {
    Pagination,
    ProductCard,
    Categories,
    Select2,
  },
  props: {
    addToCartChosenItem: {
      type: [String, Object, Number],
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
    productsFilteredBySearch: {
      type: [String, Array],
      required: true,
    },
    qualityOptions: {
      type: Array,
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      imgDomain: "",
      filtersIsVisible: true,
      sort: "desc",
      category: "",
      quality: [],
      activePage: 1,
      totalProducts: null,
      sortOptions: [
        {
          id: "desc",
          text: "Highest price first",
        },
        {
          id: "asc",
          text: "Lowest price first",
        },
      ],
      barMinValue: 0,
      barMaxValue: 1200,
      productList: "",
    };
  },
  computed: {
    newCategoryOptions() {
      let newCategories = [...this.$parent.categoryOptions];
      newCategories.unshift("All types");
      return newCategories;
    },
  },
  watch: {
    barMinValue: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    barMaxValue: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    productCategory: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    quality: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    productsFilteredBySearch: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    currencyCode() {
      this.filterProducts();
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    if (this.productCategory === "all" || this.productCategory === "search") {
      this.setProductCategory("");
    }
  },
  methods: {
    selectSort(event) {
      this.activePage = 1;
      this.sort = event.id;
      this.filterProducts();
    },
    selectCategory(event) {
      this.activePage = 1;
      this.category = event.text;
      this.$parent.setProductCategory(event.text);
      this.filterProducts();
    },
    selectQuality(event) {
      this.activePage = 1;
      this.quality = event.text;
      this.filterProducts();
    },
    resetFilters() {
      this.quality = [];
      this.setProductCategory("");
      this.$parent.getCategoryOptions();
      this.barMinValue = 0;
      this.barMaxValue = 1200;
      this.filterProducts();
    },
    toggleFilter() {
      this.filtersIsVisible = !this.filtersIsVisible;
    },
    filterProducts() {
      clearTimeout(this._filterTimer);
      this._filterTimer = setTimeout(() => this._runFilterProducts(), 120);
    },
    _runFilterProducts() {
      let addCategory = "";
      if (this.productCategory == "search") {
        addCategory = "type=";
      } else if (this.productCategory == "all") {
        addCategory = "type=";
      } else if (this.category == "All types") {
        addCategory = "type=";
      } else {
        addCategory = "type=" + this.productCategory;
      }

      let addQuality = "";
      if (this.quality != "") {
        addQuality = "&quality=" + this.quality;
      } else {
        addQuality = "";
      }
      let addPrice =
        "&price_from=" + this.barMinValue + "&price_till=" + this.barMaxValue;

      let addSort = "&sort=" + this.sort;

      let addPage = "&page=" + this.activePage;

      if (this.productCategory != "1") {
        let addCurrency = "";
        addCurrency = "&currency=" + this.$parent.currencyCode;

        this.$http
          .get(
            process.env.VUE_APP_API +
              "items/list?" +
              addCategory +
              addQuality +
              addPrice +
              addSort +
              addPage +
              "&limit=20" +
              "&search=" +
              this.productsFilteredBySearch,
          )
          .then((res) => {
            this.productList = res.data.payload;
            this.totalProducts = res.data.meta.total;
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.$parent.openSignIn();
            }
          });
      }
    },
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },
    addToCart(item, id) {
      this.$emit("addToCart", item, id);
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    setProductCategory(category) {
      this.$emit("setProductCategory", category);
    },
  },
};
</script>
